var React = require('react');

function IconForward (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M10 2v20h4V2h-4zm0-2h4a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z","fillRule":"nonzero","key":0}),React.createElement("rect",{"y":"11","width":"4","height":"2","rx":"1","key":1}),React.createElement("rect",{"x":"6","y":"11","width":"4","height":"2","rx":"1","key":2}),React.createElement("rect",{"x":"14","y":"11","width":"8","height":"2","rx":"1","key":3}),React.createElement("path",{"d":"M18.341 14.747a1 1 0 0 0 1.318 1.506l4-3.5a1 1 0 0 0 0-1.506l-4-3.5a1 1 0 1 0-1.318 1.506L21.481 12l-3.14 2.747z","fillRule":"nonzero","key":4})]));
}

IconForward.defaultProps = {"width":"24","height":"24"};

module.exports = IconForward;

IconForward.default = IconForward;
